import React from 'react'
import "./Message.css"

const Message = ({user,message,classs}) => {
    if(user){
        return (
            <div className={`messageBox ${classs}`}>
            <span className='bolder'>{user}</span>: {message}
            </div>
        )
    }
    return (
        <div className={`messageBox ${classs}`}>
        <span className='bolder'>You</span>: {message}
        </div>
    )
}

export default Message
